import { PeelingRateBasedEnum } from "../enums"

export class DeheadingPeelingRequest{
    deheadingpeelingId:number
    scopeOfWork:string
    grade:string
    minGrade:number
    maxGrade:number
    ratePerKg:number
    isActive: boolean;
    createdUser: string;
    updatedAt: Date;
    createdAt:Date;
    updatedUser: string;
    versionFlag: number;
    foodTypeId?:number
    valueAddition1?: number
    valueAddition2?: number
    basedon?:PeelingRateBasedEnum
    valueAddition3?: number
    isRRP?: string
    
    constructor(
        deheadingpeelingId:number,
        scopeOfWork:string,
        grade:string,
        minGrade:number,
        maxGrade:number,
        ratePerKg:number,
        isActive: boolean,
        createduser:string,
        updatedAt: Date,
        updateuser:string,
        versionflag:number,
        createdAt:Date,
        foodTypeId?: number,
        valueAddition1?: number,
        valueAddition2?: number,
        basedon?:PeelingRateBasedEnum,
        valueAddition3?: number,
        isRRP?: string

    ){
        this.deheadingpeelingId=deheadingpeelingId
        this.scopeOfWork=scopeOfWork
        this.grade=grade
        this.maxGrade=maxGrade
        this.minGrade=minGrade
        this.ratePerKg=ratePerKg
        this.isActive=isActive
        this.createdUser=createduser
        this.updatedAt=updatedAt
        this.updatedUser=updateuser
        this.versionFlag=versionflag
        this.createdAt=createdAt
        this.valueAddition1= valueAddition1
        this.valueAddition2 = valueAddition2
        this.foodTypeId = foodTypeId
        this.basedon = basedon
        this.valueAddition3= valueAddition3
        this.isRRP = isRRP
    }
}
export class DeheadingPeelingRequestDto{
    data:DeheadingPeelingRequest[]
    user:string
    basedon:PeelingRateBasedEnum
    constructor(
        data:DeheadingPeelingRequest[],
        user:string,
        basedon:PeelingRateBasedEnum
    )
    {
        this.data = data
        this.user = user
        this.basedon = basedon; 
    }
}